import { useQuery } from 'react-query'
import { getAdVideo } from '../Apis/livestream/adVideo'
import { adVideoKey } from './useStreamState'

/**
 * The ad video standing in for the stream: null while the game is on air, `{ source: 'ClientAd',
 * mediaId, filename }` for one of the event's own videos, `{ source: 'MismatchAd' }` for a Mismatch
 * ad. Read on mount and on window focus; useStreamState keeps it current over the stream's live hub.
 */
const useStreamAdVideo = (orgId, streamId, enabled) => {
  const { data: adVideo = null } = useQuery(
    adVideoKey(streamId),
    () => getAdVideo(orgId, streamId),
    {
      enabled: Boolean(enabled && orgId && streamId),
      refetchOnWindowFocus: true,
      retry: false,
    },
  )

  return { adVideo }
}

export default useStreamAdVideo
